import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

export function* getPurchaseSettlementDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.PURCHASE_SETTLEMENT_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.PURCHASE_SETTLEMENT_DETAILS_FAILURE });
        return error;
    }
}


export default function* purchaseSettlementSaga() {
    yield all([
        takeEvery(actions.PURCHASE_SETTLEMENT_DETAILS_START, getPurchaseSettlementDetails)
    ]);
}